import React, { useEffect } from "react";
import Grid from "@mui/material/Grid2";
import Navigation from "../../Components/Navigation";
import Footer from "../../Components/Footer";
import { Button } from "@mui/material";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Link } from "@mui/material";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";

import ContactRibbon from "../../Components/ContactRibbon";
import HeroAlt from "../../Components/HeroAlt";

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Contact Us";
  }, []);
  return (
    <main>
      <Navigation />
      <HeroAlt title="Contact Us" />

      <section padding="2% 2%">
        <Grid
          container
          size={12}
          justifyContent="center"
          padding="2% 0"
          spacing={2}
          backgroundColor="#f4f4f4"
        >
          {/*CURRENT MEETINGS SECTION */}
          <Grid item size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }} container>
            
            <Grid size={12} padding="1% 0">
              <p>
                There are multiple ways to stay informed about Forward Focus:
                Eastern Alachua County. You can email County staff directly,
                fill out comment forms, sign up for email press releases, and
                follow Alachua County on social media for updates.{" "}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </section>

      <section padding="2% 2%">
        <Grid
          container
          size={12}
          justifyContent="center"
          padding="2% 0"
          spacing={2}
          backgroundColor="#f4f4f4"
        >
          <Grid item size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }} container>
            <Grid size={12}>
              <h1>Assistant Forms</h1>
            </Grid>
            <Grid container spacing={4} size={12} paddingBottom="4%">
              <Grid container size={12} justifyContent="center">
                {/* First Card */}
                <Grid
                  container
                  item
                  size={{ xs: 11, sm: 11, md: 6, lg: 4, xl: 4 }}
                >
                  <Card>
                    <CardActionArea>
                      <CardContent>
                        <Link
                          sx={{
                            color: "#117E76",
                            fontWeight: "bold",
                            textDecorationColor: "#117E76",
                          }}
                          href="https://wkf.ms/3YknyTi"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Organization Registration Form
                        </Link>
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                          paddingTop="4%"
                        >
                          Complete this form to register your organization to
                          assist in identifying services and programs available
                          in Eastern Alachua County
                        </Typography>
                        <Button
                          href="https://wkf.ms/3YknyTi" // The external URL
                          target="_blank"
                          sx={{
                            marginTop: 2,
                            textAlign: "center",
                            background: "#020202",
                            color: "white",
                            width: "100%",
                            textDecoration: "underline",
                          }}
                          className="alt-button"
                        >
                          View Form
                        </Button>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
                <Grid
                  container
                  item
                  size={{ xs: 11, sm: 11, md: 6, lg: 4, xl: 4 }}
                >
                  <Card>
                    <CardActionArea>
                      <CardContent>
                        <Link
                          sx={{
                            color: "#117E76",
                            fontWeight: "bold",
                            textDecorationColor: "#117E76",
                          }}
                          href="https://wkf.ms/3A9J4m1"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Individual Household Assistance
                        </Link>
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                          paddingTop="4%"
                        >
                          Please complete the Comment Form to share any
                          feedback, suggestions, questions, or concerns related
                          to Eastern Alachua County.
                        </Typography>
                        <Button
                          href="https://wkf.ms/3A9J4m1" // The external URL
                          target="_blank"
                          sx={{
                            marginTop: 2,
                            textAlign: "center",
                            background: "#020202",
                            color: "white",
                            width: "100%",
                            textDecoration: "underline",
                          }}
                          className="alt-button"
                        >
                          View Form
                        </Button>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
                <Grid
                  container
                  item
                  size={{ xs: 11, sm: 11, md: 6, lg: 4, xl: 4 }}
                >
                  <Card>
                    <CardActionArea>
                      <CardContent>
                        <Link
                          sx={{
                            color: "#117E76",
                            fontWeight: "bold",
                            textDecorationColor: "#117E76",
                            textAlign: "center",
                          }}
                          href="https://wkf.ms/3Zk7gf9"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Comment Forms
                        </Link>
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                          paddingTop="4%"
                        >
                          Please complete the individual Assistance Form to
                          Request household assistance for specific needs and
                          services
                        </Typography>
                        <Button
                          href="https://wkf.ms/4jlqDeG" // The external URL to new Monday Form for board ID : 8854597261 updated on 4/9/25
                          target="_blank"
                          className="alt-button"
                          sx={{
                            marginTop: 2,
                            textAlign: "center",
                            background: "#020202",
                            color: "white",
                            width: "100%",
                            textDecoration: "underline",
                          }} // Optional: Adds margin to the top of the button
                        >
                          View Form
                        </Button>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </section>

      {/* CODE FOR THE CONTACT US RIBBON */}
      <section className="contact-container">
        <ContactRibbon />
      </section>

      <Footer />
    </main>
  );
}
